export const PENDING_SELECTION_NAME = "…";
export const UNAVAILABLE_SELECTION_NAME = "—";

/** Display names never fall back to internal selection IDs. */
export const getSelectionLabel = (name, loading = false) =>
  name || (loading ? PENDING_SELECTION_NAME : UNAVAILABLE_SELECTION_NAME);
